module.exports = __webpack_public_path__ + "bg-login.62f50bcc25d6b7371565";


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/assets/otacon/img/bg-login.jpg
// module id = ../../../../../src/assets/otacon/img/bg-login.jpg
// module chunks = main